
const sm2 = require('sm-crypto').sm2
const mysm = 'HuNanHeHuiKeJiYouXianGongSi_2023'
const keypair = getKeypair(mysm)

// 公钥加密
export function getKeypair (pwd) {
  const pairObj = sm2.generateKeyPairHex(pwd)
  return pairObj
}

// 公钥
export function getPublicKey () {
  const publicKey = keypair.publicKey.toUpperCase()
  return publicKey
}

// 私钥
export function getPrivateKey () {
  const privateKey = keypair.privateKey.toUpperCase()
  return privateKey
}

// 加密
export function toEncryption (data) {
  console.log('===加密toEncryption===', keypair)
  const xcipher = sm2.doEncrypt(data, keypair.publicKey.toUpperCase())
  return xcipher
}

// 解密
export function toDeciphering (data) {
  console.log('===解密toDeciphering===', keypair)
  const cipher = sm2.doDecrypt(data, keypair.privateKey.toUpperCase())
  return cipher
}
